module.exports = __webpack_public_path__ + "static/media/LTBox.7e2a18ed.png";